
import { supabase } from '@/integrations/supabase/client';
import { PublicCourseData } from '@/types/public-course-2';

export class PublicCourseService {
  static async getCourseBySlug(username: string, courseSlug: string): Promise<PublicCourseData> {
    const { data, error } = await supabase.rpc(
      'get_public_course',
      { 
        p_username: username, 
        p_slug: courseSlug 
      }
    );

    if (error) {
      console.error('Error fetching public course:', error);
      throw error;
    }
    
    if (!data) {
      // Return a notFound indicator instead of throwing an error
      return { notFound: true } as PublicCourseData;
    }
    
    // Cast to unknown first, then to PublicCourseData to avoid TypeScript errors
    return data as unknown as PublicCourseData;
  }

  static async isUserEnrolled(userId: string, courseId: string): Promise<boolean> {
    const { data, error } = await supabase.rpc(
      'get_enrollment_status',
      { p_user_id: userId, p_course_id: courseId }
    );

    if (error) {
      console.error('Error checking enrollment:', error);
      throw error;
    }

    return !!data;
  }

  static async enrollUserInCourse(userId: string, courseId: string): Promise<void> {
    const { error } = await supabase
      .from('enrollments')
      .insert([
        { 
          user_id: userId,
          course_id: courseId,
          status: 'active'
        }
      ]);

    if (error) {
      console.error('Error enrolling user:', error);
      throw error;
    }
  }
}
